<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import useUserStore from '~/store/user'
import usePoolStore from '~/store/pool'

const emits = defineEmits(['layoutLoaded'])
const config = useRuntimeConfig()

const { APPLICATION_URL, NODE_ENV } = config.public
const route = useRoute()
const { locale } = useI18n()
const { href } = useRequestURL()

const locales = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt']

const favicon = computed(() => `${APPLICATION_URL}/favicon.svg`)

watch(
    () => route.fullPath,
    () => {
        usePoolStore().setPoolSlug((route.params.slug as string) || '')
    },
    { deep: true, immediate: true }
)

useSeoMeta({
    ogType: 'website',
    ogLocale: locale,
    ogLocaleAlternate: locales,
    ogImage: favicon.value,
    ogUrl: href,
    robots: { noindex: NODE_ENV !== 'production' }
})

onBeforeMount(() => {
    useUserStore().fetchChargemapUsersCount()
    emits('layoutLoaded')
})
</script>

<template>
    <Html :lang="locale" />
    <Head>
        <Link
            rel="apple-touch-icon"
            type="image/png"
            sizes="180x180"
            :href="`${APPLICATION_URL}/meta/apple-touch-icon.png`"
        />
        <Link rel="icon" type="image/svg" :href="favicon" />
        <Link
            rel="mask-icon"
            color="#5bbad5"
            :href="`${APPLICATION_URL}/meta/safari-pinned-tab.svg`"
        />
        <Link rel="canonical" crossorigin="use-credentials" :href />
        <Link
            rel="manifest"
            crossorigin="use-credentials"
            :href="`${APPLICATION_URL}/meta/site.webmanifest`"
        />

        <Meta name="theme-color" content="#ffffff" />
    </Head>
    <slot />
</template>
